@import (reference) '../../../../constants/spacing.module.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.fulfillment-plan-tags {
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: @space-16;
  flex: 1;
}

.fulfillment-plan-tags-dropdown-menu {
  max-height: 450px;
  width: 240px !important;
}

.fulfillment-plan-tags-dropdown-menu-item {
  display: flex;
  align-items: center;
  height: 35px;
}

.fulfillment-plan-tag-dropdown-header {
  display: flex;
  align-items: center;
  gap: @space-8;
  border-bottom: none;
  height: 35px;
}

.fulfillment-plan-tag-dropdown-body {
  max-height: 300px;
  border-top: 1px solid var(--default--border-color--12);
  overflow-y: auto;
}

.no-tags-indicator {
  color: @tag-dropdown--no-tags-indicator--text-color;
  font-style: italic;
  height: 121px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: @space-8;
  padding: @space-24 @space-8 @space-16;
  width: 176px;
}

.fulfillment-plan-tag-dropdown-footer {
  padding: @space-8;
  border-top: 1px solid var(--default--border-color--12);
  display: flex;
  flex-direction: column;
  gap: @space-8;
}

.fulfillment-plan-tag-dropdown-footer-actions {
  display: flex;
  flex-direction: row;
  gap: @space-8;
  justify-content: space-between;
}

.fulfillment-plan-tag-dropdown-footer-action {
  padding: @space-8 @space-12;
  align-items: center;
  display: flex;
  font-size: 12px;
}

.fulfillment-plan-tag-dropdown-footer-checkbox {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
